const APPOINTMENT_URL_PREFIX = "/video-chat?code=";

export default APPOINTMENT_URL_PREFIX;
